// Add your JS customizations here
document.addEventListener('DOMContentLoaded', function () {
    const navbar = document.getElementById('wrapper-navbar');
    const offcanvasElement = document.getElementById('navbarNavOffcanvas');
    let isOffcanvasOpen = false;

    // -----------------------------------------------------------------
    // Lenis Smooth Momentum Scroll Initialization (Endast Desktop)
    // -----------------------------------------------------------------
    let lenis = null;
    const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

    // Endast aktivera Lenis på desktop med mushjul – pekskärmar har redan inbyggd hårdvaruaccelererad momentum-scroll
    if (!isTouchDevice && typeof Lenis !== 'undefined') {
        lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Silky exponential ease-out
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 0,
            infinite: false,
        });

        function lenisRaf(time) {
            lenis.raf(time);
            requestAnimationFrame(lenisRaf);
        }
        requestAnimationFrame(lenisRaf);

        window.sertionLenis = lenis;
    }

    // Lyssna på när offcanvas öppnas eller stängs så vi kan pausa scroll-effekten
    if (offcanvasElement) {
        offcanvasElement.addEventListener('show.bs.offcanvas', function () {
            isOffcanvasOpen = true;
            if (lenis) lenis.stop();
        });
        offcanvasElement.addEventListener('hidden.bs.offcanvas', function () {
            isOffcanvasOpen = false;
            if (lenis) lenis.start();
        });
    }

    if (!navbar) return;

    let lastScrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop);
    let ticking = false;
    const scrollThreshold = 8; // Minsta delta i pixlar för att undvika mikrojitter och flimmer
    const navbarHeight = navbar.offsetHeight || 78;
    const minScrollForSticky = 250; // Måste ha scrollat ner minst 250px innan sticky-menyn fälls fram vid upp-scroll

    function updateNavbar() {
        const currentScrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop);

        // Om offcanvas är öppen, pausa scroll-hanteringen
        if (isOffcanvasOpen) {
            ticking = false;
            return;
        }

        // 1. Högst upp på sidan (eller inom 10px från toppen)
        if (currentScrollTop <= 10) {
            navbar.classList.remove('nav-scrolled-down');
            navbar.classList.remove('nav-scrolled-up');
            lastScrollTop = currentScrollTop;
            ticking = false;
            return;
        }

        const scrollDelta = currentScrollTop - lastScrollTop;

        // 2. Kontrollera om scroll-rörelsen är tillräckligt stor
        if (Math.abs(scrollDelta) < scrollThreshold) {
            ticking = false;
            return;
        }

        if (scrollDelta > 0 && currentScrollTop > navbarHeight) {
            // Skrollar neråt och har passerat headern -> dölj navbaren
            if (!navbar.classList.contains('nav-scrolled-down')) {
                navbar.classList.add('nav-scrolled-down');
                navbar.classList.remove('nav-scrolled-up');
            }
        } else if (scrollDelta < 0) {
            // Skrollar uppåt
            if (currentScrollTop > minScrollForSticky) {
                // Längre ner på sidan: fäll fram sticky-menyn
                if (!navbar.classList.contains('nav-scrolled-up')) {
                    navbar.classList.remove('nav-scrolled-down');
                    navbar.classList.add('nav-scrolled-up');
                }
            } else {
                // Nära toppen (under 250px): fäll inte fram sticky-menyn, utan låt toppen nås naturligt
                navbar.classList.remove('nav-scrolled-down');
                navbar.classList.remove('nav-scrolled-up');
            }
        }

        lastScrollTop = currentScrollTop;
        ticking = false;
    }

    if (lenis) {
        lenis.on('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(updateNavbar);
                ticking = true;
            }
        });
    } else {
        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(updateNavbar);
                ticking = true;
            }
        }, { passive: true });
    }
});
